import { PanelRow, RangeControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

import { BtnGroup, Label } from '../../../../Components';
import { aligns } from '../../utils/options';
import Column from '../../settings/Components/Column/Column'
import Row from '../../settings/Components/Row/Row'

const SwipeLayoutPanel = ({ data, setData }) => {
    const { width = 100, layoutAlign } = data;
    return <Row gap={10}>
        <Column span={6}>
            <RangeControl label={__('Width', 'bpwsnb')} value={width} onChange={(val) => setData({ ...data, width: val })} min={2} max={100} />
        </Column>
        <Column span={6}>
            <PanelRow>
                <Label className=''>{__('Align:', 'bpwsnb')}</Label>
                <BtnGroup value={layoutAlign} onChange={val => setData({ ...data, layoutAlign: val })} options={aligns} isIcon={true} />
            </PanelRow>
        </Column>
    </Row>
}
export default SwipeLayoutPanel;